/* eslint-disable no-nested-ternary */
const emailRegex =
  /^(([^<>()\]\\.,;:\s@"]+(\.[^<>()\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export const validationState = {
  phoneInvalid: '',
  validationInvalid: false
};

export function validationReducer(state = validationState, action) {
  const { payload, type } = action;

  switch (type) {
    case 'phone':
    case 'input-phone':
      const strPayload = payload?.toString();
      const validatePhone =
        !strPayload ||
        (strPayload && !strPayload?.startsWith('0') && strPayload?.length < 13)
          ? ''
          : 'Invalid phone number';

      return {
        ...state,
        phoneInvalid: validatePhone,
        validationInvalid: !!validatePhone
      };

    case 'email':
      const validateEmail =
        !payload || emailRegex.test(payload)
          ? ''
          : payload.includes('@')
            ? 'Invalid email'
            : 'An email address must be contain a single @';

      return {
        ...state,
        emailInvalid: validateEmail,
        validationInvalid: !!validateEmail
      };
    default:
      return state;
  }
}
